import { type ReactElement } from 'react';
import { OrganizationSettingsContent } from './org/OrganizationSettingsContent';
import { PersonalSettingsContent } from './personal/PersonalSettingsContent';
import { type SettingsContext } from './config/settingsContext';

type Props = {
  context: SettingsContext;
};

export function SettingsPageShell({ context }: Props): ReactElement {
  if (context === 'organization') {
    return <OrganizationSettingsContent />;
  }

  return <PersonalSettingsContent />;
}
